import React, { memo } from 'react';
import LargeLabel from 'base/components/LargeLabel';
import Repeat from 'base/components/Repeat';
import Skeleton from 'base/components/Skeleton';
import Teaser from 'base/components/Teaser';

const FileExplorerTeaserSkeleton = () => (
  <Repeat
    times={5}
    render={(i) => (
      <Teaser.Wrapper key={i}>
        <Teaser.IconCol>
          <Skeleton
            width="25px"
            height="25px"
            borderRadius="50px"
            heightRandomness={0}
            widthRandomness={0}
          />
        </Teaser.IconCol>
        <Teaser.MainCol style={{ width: '100%' }}>
          <Skeleton width="80px" height="10px" />
          <LargeLabel><Skeleton width="80%" /></LargeLabel>
          <Teaser.MetaWrapper style={{ display: 'block' }}>
            <Skeleton width="70%" height="8px" />
          </Teaser.MetaWrapper>

        </Teaser.MainCol>
      </Teaser.Wrapper>
    )}
  />
);

export default memo(FileExplorerTeaserSkeleton);
